<div class="select-content-container">
	<div class="select-content-title-container">
		<span class="title-description" translate>dashboard.condition</span>
		<copo-slide-button labelAfter="dashboard.steelgrade"
							labelBefore="dashboard.customer-material-reference"
							(toggleChange)="onToggleChange($event)"
							[checked]="steelgradeSelected"
		></copo-slide-button>
	</div>
</div>
